import type { Order } from './types';

export const statusColors: Record<string, string> = {
  pending: 'processing',
  success: 'success',
  failed: 'error',
};

export const statusLabels: Record<string, string> = {
  pending: '处理中',
  success: '已完成',
  failed: '失败',
};

export const clientStatusColors: Record<string, string> = {
  applying: 'processing',
  opening: 'gold',
  shipping: 'cyan',
  activated: 'success',
  closed: 'error',
};

export const exceptionStatusLabels: Record<string, string> = {
  pending_auto_retry: '等待自动重提',
  needs_manual_retry: '需要手动重提',
  sync_failed: '同步失败',
  manual_open: '人工打开',
  resolved: '已处理',
};

export const exceptionStatusColors: Record<string, string> = {
  pending_auto_retry: 'processing',
  needs_manual_retry: 'error',
  sync_failed: 'warning',
  manual_open: 'orange',
  resolved: 'success',
};

export const resolveStatusText = (
  order: Pick<Order, 'clientStatusText' | 'displayStatus' | 'platformStatusText' | 'status'>,
) =>
  order.clientStatusText || order.displayStatus || order.platformStatusText || statusLabels[order.status] || order.status;

export const resolveStatusColor = (order: Pick<Order, 'clientStatus' | 'status'>) =>
  clientStatusColors[order.clientStatus || ''] || statusColors[order.status] || 'default';
